<template>
    <div v-if="purchase">
        <b-container fluid class="main_layer py-2">
            <b-container>
                <p class="fs-40 fw-600 white-color my-2">Преобразование закупки 44ФЗ с неопределённым объёмом № {{ purchase.reg_number }} в несрочную</p>
            </b-container>
        </b-container>
        <b-container fluid class="my-2">
            <b-container>
                <text-header>Информация о заказчике</text-header>
                <text-row-link compact :label-cols-lg="4" :label-cols-sm="4" label="Наименование" v-model="purchase.customer.full_name" :router-link="{ name: 'OrganizationShow', params: { id: purchase.customer.id } }" />
                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="ИНН" v-model="purchase.customer.inn" />
                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="КПП" v-model="purchase.customer.kpp" />
                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="ОГРН" v-model="purchase.customer.ogrn" />
                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Юридический адрес" v-model="purchase.customer.legal_address" />
                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Дополнительная контактная информация" v-model="purchase.purchase_terms.contact_info" v-if="purchase.purchase_terms.contact_info" />

                <text-header>Условия закупки</text-header>
                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Предмет закупки" :value="purchase.purchase_terms.deliverable_group.name" />
                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Объект закупки" :value="purchase.purchase_terms.purchase_object" />
                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Тип закупки" :value="purchase.purchase_terms.order_type.name" />
                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Продолжительность закупочной сессии" :value="purchase.purchase_terms.duration_type.name" />
                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Размер аванса, %" :value="purchase.purchase_terms.advance_percentage" />
                <text-row-price compact :label-cols-lg="4" :label-cols-sm="4" label="Цена контракта" :value="purchase.purchase_terms.contract_price" />
                <text-row-date compact :label-cols-lg="4" :label-cols-sm="4" label="Планируемая дата заключения договора" :value="purchase.purchase_terms.planned_contract_conclusion_date" />
                <text-row-date compact :label-cols-lg="4" :label-cols-sm="4" label="Планируемая дата исполнения договора" :value="purchase.purchase_terms.planned_contract_execution_date" />
                <text-row-single-document compact :label-cols-lg="4" :label-cols-sm="4" label="Проект ГК" :value="purchase.purchase_terms.contract_draft_attachment" />
                <text-row-single-document v-if="purchase.purchase_terms.commercial_proposal_form_attachment" compact :label-cols-lg="4" :label-cols-sm="4" label="Образец коммерческого предложения для заполнения" :value="purchase.purchase_terms.commercial_proposal_form_attachment" />
                <text-row-documents compact :label-cols-lg="4" :label-cols-sm="4" label="Дополнительные документы" v-model="purchase.additional_documents" v-if="purchase.additional_documents.length > 0" />
                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Информация о возможности и случаях одностороннего расторжения сделки в соответствии с действующим законодательством Российской Федерации" :value="purchase.purchase_terms.unilateral_contract_termination_info ?? 'Нет'" text-wrap />

                <text-header>Требования к участникам закупки</text-header>
                <text-row-boolean-text compact :label-cols-lg="11" :label-cols-sm="11" label="Участником закупки могут быть только субъекты малого предпринимательства (СМП)" :value="purchase.supplier_requirements.only_smp" value-class="text-right" />
                <text-row-boolean-text
                    compact
                    :label-cols-lg="11"
                    :label-cols-sm="11"
                    label="Установить требование к участникам по рейтингу с возможностью отклонения предложения участника с рейтингом ниже 4,5 балла"
                    :value="purchase.supplier_requirements.supplier_reqs_rating"
                    value-class="text-right" />
                <text-row-boolean-text
                    compact
                    :label-cols-lg="11"
                    :label-cols-sm="11"
                    label="Соответствие участника закупки требованиям п.1 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ"
                    :value="purchase.supplier_requirements.supplier_reqs_a"
                    value-class="text-right" />
                <b-container v-if="purchase.supplier_requirements.supplier_reqs_a">
                    <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Описание требований" :value="purchase.supplier_requirements.supplier_reqs_a_details.supplier_reqs_a_text" text-wrap />
                    <b-form-group :label-cols-sm="4" :label-cols-lg="4" label="Подтверждающие документы:" label-class="fs-14 grey-color fw-700 d-flex align-items-baseline" class="mb-0">
                        <ul>
                            <li v-for="(item, index) in purchase.supplier_requirements.supplier_reqs_a_details.supplier_reqs_a_documents" :key="index" class="fs-14 grey-color my-auto col-form-label pb-0">{{ index + 1 + '. ' + item.name }}</li>
                        </ul>
                    </b-form-group>
                </b-container>
                <text-row-boolean-text
                    compact
                    :label-cols-lg="11"
                    :label-cols-sm="11"
                    label="Соответствие участника закупки требованиям п.3-5, 7-11 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ"
                    :value="purchase.supplier_requirements.supplier_reqs_b"
                    value-class="text-right" />
                <text-row-boolean-text
                    compact
                    :label-cols-lg="11"
                    :label-cols-sm="11"
                    label="Соответствие участника закупки требованиям ч.1.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ"
                    :value="purchase.supplier_requirements.supplier_reqs_c"
                    value-class="text-right" />
                <text-row-boolean-text compact :label-cols-lg="11" :label-cols-sm="11" label="Участник является социально ориентированной некоммерческой организацией (СОНКО)" :value="purchase.supplier_requirements.supplier_reqs_sonko" value-class="text-right" />
                <text-row-boolean-text compact :label-cols-lg="11" :label-cols-sm="11" label="Дополнительные требования к участникам закупки" :value="purchase.supplier_requirements.has_additional_requirements" value-class="text-right" />
                <div v-show="purchase.supplier_requirements.has_additional_requirements">
                    <section style="width: 100%">
                        <div class="table-responsive">
                            <table class="atmo-content-table mb-0">
                                <thead>
                                <tr>
                                    <th class="atmo-ctc-width-45pct py-1">Описание</th>
                                    <th class="atmo-ctc-width-45pct py-1">Причина или цель установки требования</th>
                                </tr>
                                </thead>

                                <tbody>
                                <tr v-for="(requirement, index) in purchase.supplier_requirements.additional_requirements" v-bind:key="index">
                                    <td class="atmo-ctc-width-45pct py-1">{{ requirement.description }}</td>
                                    <td class="atmo-ctc-width-45pct py-1">{{ requirement.reason }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </section>
                </div>

                <template v-if="purchase.delivery_terms.addresses.length > 0 || purchase.delivery_terms.schedule">
                    <text-header>Условия поставки</text-header>
                    <b-form-group v-if="purchase.delivery_terms.addresses.length > 0" :label-cols-sm="4" :label-cols-lg="4" label="Адреса для доставки/самовывоза:" label-class="py-0 fs-14 grey-color fw-700 d-flex align-items-baseline" class="mb-0">
                        <ul>
                            <li v-for="(address, index) in purchase.delivery_terms.addresses" :key="index" class="py-0 fs-14 grey-color my-auto col-form-label">{{ address }}</li>
                        </ul>
                    </b-form-group>
                    <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="График поставки товаров (выполнения работ, оказания услуг)" :value="purchase.delivery_terms.schedule" />
                </template>

                <form-row-specification-table-view v-model="purchase.deliverables" without-count />

                <b-row class="my-3 mt-5">
                    <b-col>
                        <b-button class="mx-2 text-uppercase" variant="custom-outline-secondary" @click="onCancel">Отменить</b-button>
                        <b-button :disabled="!$store.getters.getCanSign" class="text-uppercase mx-2" variant="custom-green" @click="validateForm">Подписать и сохранить</b-button>
                        <template v-if="!$store.getters.getCanSign">
                            <span v-if="$store.getters.getLoginType === 'cert'" class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">Для действия требуется загрузить/заменить МЧД на странице: <router-link :to="{ name: 'CabinetUserProfile' }" class="green-link">Данные учетной записи</router-link></span>
                            <span v-else class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">Подписание возможно только при авторизации при помощи ЭЦП</span>
                        </template>
                    </b-col>
                </b-row>
            </b-container>
        </b-container>
        <b-modal ref="sign-form-modal" v-model="showSignModal" centered no-close-on-backdrop no-close-on-esc scrollable size="lg" title="Подписать извещение" @close="cancelSignModal">
            <template #modal-header-close>
                <button-close-modal />
            </template>
            <div class="d-block text-left">
                <b-tabs content-class="mt-3 px-3">
                    <b-tab active>
                        <template #title>
                            <span class="system_link-style fs-16">Форма</span>
                        </template>
                        <h4 class="font-weight-bold">Информация о заказчике</h4>
                        <text-row compact label="Наименование организации" :value="purchase.customer.name" />
                        <text-row compact label="ИНН" :value="purchase.customer.inn" />
                        <text-row compact label="КПП" :value="purchase.customer.kpp" />
                        <text-row compact label="ОГРН" :value="purchase.customer.ogrn" />
                        <text-row compact label="Адрес" :value="purchase.customer.legal_address" />
                        <text-row compact label="Дополнительная контактная информация" :value="purchase.purchase_terms.contact_info" />

                        <hr />
                        <h4 class="font-weight-bold">Условия закупки</h4>
                        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Объект закупки" :value="purchase.purchase_terms.purchase_object" />
                        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Предмет закупки" :value="purchase.purchase_terms.deliverable_group.name" />
                        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Тип закупки" :value="purchase.purchase_terms.order_type.name" />
                        <text-row-price compact :label-cols-lg="4" :label-cols-sm="4" label="Цена контракта" :value="purchase.purchase_terms.contract_price" />
                        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Продолжительность закупочной сессии" :value="purchase.purchase_terms.duration_type.name" />
                        <text-row-boolean-text compact :label-cols-lg="4" :label-cols-sm="4" label="Аванс" :value="purchase.purchase_terms.with_advance" />
                        <text-row v-if="purchase.purchase_terms.with_advance" compact :label-cols-lg="4" :label-cols-sm="4" label="Размер аванса" :value="purchase.purchase_terms.advance_percentage + '%'" />
                        <text-row-date compact :label-cols-lg="4" :label-cols-sm="4" label="Планируемая дата заключения договора" :value="purchase.purchase_terms.planned_contract_conclusion_date" />
                        <text-row-date compact :label-cols-lg="4" :label-cols-sm="4" label="Планируемая дата исполнения договора" :value="purchase.purchase_terms.planned_contract_execution_date" />
                        <text-row-single-document compact :label-cols-lg="4" :label-cols-sm="4" label="Проект ГК" :value="purchase.purchase_terms.contract_draft_attachment" />
                        <text-row-single-document v-if="purchase.purchase_terms.commercial_proposal_form_attachment" compact :label-cols-lg="4" :label-cols-sm="4" label="Образец коммерческого предложения для заполнения" :value="purchase.purchase_terms.commercial_proposal_form_attachment" />
                        <text-row
                            compact
                            :label-cols-lg="4"
                            :label-cols-sm="4"
                            label="Информация о возможности и случаях одностороннего расторжения сделки в соответствии с действующим законодательством Российской Федерации"
                            :value="purchase.purchase_terms.unilateral_contract_termination_info"
                            text-wrap />

                        <hr />
                        <h4 class="font-weight-bold">Требования к участникам закупки</h4>
                        <text-row-boolean-text compact :label-cols-lg="11" :label-cols-sm="11" label="Участником закупки могут быть только субъекты малого предпринимательства (СМП)" :value="purchase.supplier_requirements.only_smp" value-class="text-right" />
                        <text-row-boolean-text
                            compact
                            :label-cols-lg="11"
                            :label-cols-sm="11"
                            label="Установить требование к участникам по рейтингу с возможностью отклонения предложения участника с рейтингом ниже 4,5 балла"
                            :value="purchase.supplier_requirements.supplier_reqs_rating"
                            value-class="text-right" />
                        <text-row-boolean-text
                            compact
                            :label-cols-lg="11"
                            :label-cols-sm="11"
                            label="Соответствие участника закупки требованиям п.1 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ"
                            :value="purchase.supplier_requirements.supplier_reqs_a"
                            value-class="text-right" />
                        <b-container v-if="purchase.supplier_requirements.supplier_reqs_a">
                            <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Описание требований" :value="purchase.supplier_requirements.supplier_reqs_a_details.supplier_reqs_a_text" text-wrap />
                            <b-form-group :label-cols-sm="4" :label-cols-lg="4" label="Подтверждающие документы:" label-class="fs-14 grey-color fw-700 d-flex align-items-baseline" class="mb-0">
                                <ul>
                                    <li v-for="(item, index) in purchase.supplier_requirements.supplier_reqs_a_details.supplier_reqs_a_documents" :key="index" class="fs-14 grey-color my-auto col-form-label pb-0">{{ index + 1 + '. ' + item.description }}</li>
                                </ul>
                            </b-form-group>
                        </b-container>
                        <text-row-boolean-text
                            compact
                            :label-cols-lg="11"
                            :label-cols-sm="11"
                            label="Соответствие участника закупки требованиям п.3-5, 7-11 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ"
                            :value="purchase.supplier_requirements.supplier_reqs_b"
                            value-class="text-right" />
                        <text-row-boolean-text
                            compact
                            :label-cols-lg="11"
                            :label-cols-sm="11"
                            label="Соответствие участника закупки требованиям ч.1.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ"
                            :value="purchase.supplier_requirements.supplier_reqs_c"
                            value-class="text-right" />
                        <text-row-boolean-text compact :label-cols-lg="11" :label-cols-sm="11" label="Участник является социально ориентированной некоммерческой организацией (СОНКО)" :value="purchase.supplier_requirements.supplier_reqs_sonko" value-class="text-right" />
                        <text-row-boolean-text compact :label-cols-lg="11" :label-cols-sm="11" label="Дополнительные требования к участникам закупки" :value="purchase.supplier_requirements.has_additional_requirements" value-class="text-right" />
                        <div v-show="purchase.supplier_requirements.has_additional_requirements">
                            <section style="width: 100%">
                                <div class="table-responsive">
                                    <table class="atmo-content-table mb-0">
                                        <thead>
                                        <tr>
                                            <th class="atmo-ctc-width-45pct py-1">Описание</th>
                                            <th class="atmo-ctc-width-45pct py-1">Причина или цель установки требования</th>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        <tr v-for="(requirement, index) in purchase.supplier_requirements.additional_requirements" v-bind:key="index">
                                            <td class="atmo-ctc-width-45pct py-1">{{ requirement.description }}</td>
                                            <td class="atmo-ctc-width-45pct py-1">{{ requirement.reason }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </section>
                        </div>

                        <template v-if="purchase.delivery_terms.addresses.length > 0 || purchase.delivery_terms.schedule">
                            <hr />
                            <h4 class="font-weight-bold">Условия поставки</h4>
                            <b-form-group v-if="purchase.delivery_terms.addresses.length > 0" :label-cols-sm="4" :label-cols-lg="4" label="Адреса для доставки/самовывоза:" label-class="fs-14 grey-color fw-700 d-flex align-items-baseline" class="mb-0">
                                <ul>
                                    <li v-for="(address, index) in purchase.delivery_terms.addresses" :key="index" class="fs-14 grey-color my-auto col-form-label pb-0">{{ index + 1 + '. ' + address.address ?? address }}</li>
                                </ul>
                            </b-form-group>
                            <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="График поставки товаров (выполнения работ, оказания услуг)" :value="purchase.delivery_terms.schedule" text-wrap />
                        </template>

                        <hr />
                        <h4 class="font-weight-bold">Спецификация</h4>
                        <b-form-group v-if="purchase.deliverables.length > 0">
                            <ul>
                                <li v-for="(item, index) in purchase.deliverables" :key="index" class="fs-14 grey-color my-auto col-form-label py-1">{{ index + 1 + '.' }} {{ item.ktru_item.name }} - {{ item.ktru_item.okei_local_symbol }}</li>
                            </ul>
                        </b-form-group>

                        <template v-if="purchase.additional_documents.length > 0">
                            <hr />
                            <h4 class="font-weight-bold">Дополнительные документы</h4>
                            <text-row-documents label="Дополнительные документы" v-model="purchase.additional_documents" compact />
                        </template>
                    </b-tab>
                    <b-tab>
                        <template #title>
                            <span class="system_link-style fs-16">XML</span>
                        </template>
                        <b-form-textarea v-if="!isSignedXml" v-model="formXml" disabled rows="20" no-resize no-auto-shrink wrap="off" class="text-monospace fs-12"></b-form-textarea>
                        <b-form-textarea v-if="isSignedXml" v-model="signedFormXml" disabled rows="20" class="text-monospace fs-12"></b-form-textarea>
                    </b-tab>
                </b-tabs>
            </div>
            <div slot="modal-footer" class="w-100 px-3">
                <text-row label="Сертификат" :value="certificate?.subjectName" />
                <b-button :disabled="isDataSending" class="mr-2 text-uppercase" variant="custom-outline-secondary" @click="cancelSignModal">Отмена</b-button>
                <b-overlay v-if="!isSignedXml" :show="isSigningXml" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button :disabled="!certificate" class="text-uppercase" variant="custom-green" @click="signForm">Подписать</b-button>
                </b-overlay>
                <b-overlay v-if="isSignedXml" :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button :disabled="!certificate" class="text-uppercase" variant="custom-green" @click="sendData">Отправить</b-button>
                </b-overlay>
            </div>
        </b-modal>
    </div>
</template>

<script>

import { createMultipleSignatures, getCertificate } from 'crypto-pro';

export default {
    name: 'fl44-unknown-volume-purchase-duration-change',
    metaInfo() {
        return {
            title: `Преобразование закупки 44ФЗ с неопределённым объёмом № ${this.getRegNumber} в несрочную `
        };
    },
    data() {
        return {
            id: this.$route.params.id,
            purchase: null,
            isSigningXml: false,
            isDataSending: false,
            formXml: '',
            signedFormXml: null,
            isSignedXml: false,
            showSignModal: false,
            signedAttachments: [],
            certificate: null
        };
    },
    async mounted() {
        await this.fillData();
    },
    methods: {
        async fillData() {
            this.purchase = await this.$api.personal.fl44UnknownVolume.getDurationChangeData(this.id);
        },
        cancelSignModal() {
            this.isSignedXml = false;
            this.showSignModal = false;
        },
        async validateForm() {
            if (!this.$store.getters.getCanSign) {
                return;
            }
            this.certificate = await getCertificate(this.$store.getters.getCurrentThumbprint);
            if (!this.certificate) {
                return;
            }
            this.showSignForm();
        },
        showSignForm() {
            this.$api.personal.fl44UnknownVolume.getDurationChangeXml(this.id).then((resp) => {
                this.formXml = resp.xml;
                this.showSignModal = true;
            });
        },
        async signForm() {
            this.isSigningXml = true;
            const dataToSign = [
                {
                    method: 'xml',
                    value: this.formXml
                }
            ];
            for (const attachment of [this.purchase.purchase_terms.contract_draft_attachment, this.purchase.purchase_terms.commercial_proposal_form_attachment, ...this.purchase.additional_documents]) {
                if (attachment !== null) {
                    dataToSign.push({
                        method: 'detached',
                        value: attachment.hash
                    });
                }
            }
            try {
                const signedResult = await createMultipleSignatures(this.$store.getters.getCurrentThumbprint, dataToSign, true);
                this.signedFormXml = signedResult.find((item) => item.method === 'xml').result;
                this.signedAttachments.splice(0);
                for (const attachment of [this.purchase.purchase_terms.contract_draft_attachment, this.purchase.purchase_terms.commercial_proposal_form_attachment, ...this.purchase.additional_documents]) {
                    if (attachment !== null) {
                        const result = signedResult.find((item) => item.method === 'detached' && item.value === attachment.hash);
                        this.signedAttachments.push({
                            id: attachment.id,
                            hash: attachment.hash,
                            md5: result.result
                        });
                    }
                }
                this.isSignedXml = !!this.signedFormXml && this.signedAttachments.length === this.purchase.additional_documents.length + 1 + (this.purchase.purchase_terms.commercial_proposal_form_attachment ? 1 : 0) && this.signedAttachments.every((item) => item.md5 !== null);
            } catch (e) {
                await this.$store.dispatch('showDangerToast', e.message);
            } finally {
                this.isSigningXml = false;
            }
        },
        async sendData() {
            this.isDataSending = true;
            this.certificate = await getCertificate(this.$store.getters.getCurrentThumbprint);
            if (!this.certificate) {
                return;
            }
            await this.$api.personal.fl44UnknownVolume
                .storeSignedDurationChange(this.id, this.signedFormXml, this.certificate, this.signedAttachments)
                .then((response) => {
                    if (response) {
                        this.onCancel();
                    }
                })
                .finally(() => {
                    this.isDataSending = false;
                });
        },
        onCancel() {
            this.$router.push({ name: 'CabinetFl44NoticesList' });
        }
    },
    computed: {
        getRegNumber() {
            return this.purchase?.reg_number ?? '';
        }
    }
};
</script>

<style scoped>
.main_layer {
    background-image: url('/images/purchases_head.svg');
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    min-height: 100px;
}
.block_head-text {
    font-size: 32px;
    color: var(--grey-color);
    font-weight: 600;
    line-height: 48px;
    margin: 33px 0;
}
.table {
    border-collapse: collapse;
}

.table thead th {
    background: #e4e6e8;
    font-size: 14px;
    font-weight: 600;
    padding: 12px;
    color: var(--grey-color);
}

.table tbody td {
    font-size: 14px;
    /*font-weight: 600;*/
    padding: 12px;
    color: var(--grey-color);
    border-top: 0;
}
.table tbody tr {
    border-bottom: 1px solid #dee2e6;
}
</style>
